
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Select, Input } from 'antd';

const { TextArea } = Input;

class TripEditOther extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentWillMount() {
    }


    render() {

        return (

            <Fragment>
                <div className='module'>DİĞER</div>
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div className='label'>
                            <span>
                                SEYAHAT TİPİ
                            </span>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>

                        <Select
                            showSearch
                            placeholder="Seyahat tipi seçiniz..."
                            defaultValue={this.props.transferTypeId}
                            value={this.props.transferTypeId}
                            onSelect={(e) => this.props.onSelectTransferType(e)}
                            options={
                                this.props.transferTypes.map(item => {
                                    return {
                                        value: item.value,
                                        label: item.text,
                                    }
                                })
                            }
                        />
                    </Col>
                </Row>

                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div className='label'>
                            <span>
                                TALEP NOTU EKLEMEK İSTER MİSİNİZ?
                            </span>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>

                        <TextArea
                            rows={4}
                            value={this.props.note}
                            placeholder="Talep notu eklemek ister misiniz? (uçuş kodu, otel adı vb.)"
                            onChange={(e) => this.props.onChangeNote(e)}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Button
                            htmlType="submit"
                            type="primary"
                            className="ant-btn width-100"
                            style={{ float: "right", height: 40, marginTop: 25 }}
                            onClick={(e) => this.props.fetchTrip()}
                            loading={this.props.loadingSubmit}
                        >
                            {
                                this.props.id ?
                                    "Talebi Güncelle"
                                    :
                                    "Talep Oluştur"
                            }

                        </Button>
                    </Col>
                </Row>

            </Fragment>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripEditOther);


// WEBPACK FOOTER //
// ./src/components/App/Views/Trip/TripEditOther.js